// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yc-select-control {
  box-sizing: border-box;
  position: relative;
  display: inline-flex;
  align-items: center;
  padding-left: 8px;
  border: 1px solid var(--g-color-line-generic);
  border-radius: 3px;
  -webkit-user-select: none;
          user-select: none;
  transition: border-color 0.1s linear, background-color 0.1s linear;
  cursor: pointer;
  outline: none;
  color: var(--g-color-text-primary);
  background-color: var(--yc-select-background-color, "none");
}
.yc-select-control_size_xs {
  height: 24px;
  line-height: 24px;
  font-size: 13px;
  border-radius: var(--g-border-radius-s);
}
.yc-select-control_size_s {
  height: 28px;
  line-height: 28px;
  font-size: 13px;
  border-radius: var(--g-border-radius-m);
}
.yc-select-control_size_m {
  height: 32px;
  line-height: 36px;
  font-size: 13px;
  border-radius: var(--g-border-radius-l);
}
.yc-select-control_size_n {
  height: 36px;
  line-height: 36px;
  font-size: 13px;
  border-radius: var(--g-border-radius-xl);
}
.yc-select-control_size_promo {
  height: 44px;
  line-height: 44px;
  font-size: 15px;
  padding-left: 12px;
}
.yc-select-control_size_promo .yc-select-control__tokens-text {
  padding-right: 12px;
}
.yc-select-control_focused, .yc-select-control_focused.yc-select-control:hover:not(.yc-select-control_error), .yc-select-control:focus:not(.yc-select-control_error) {
  border-color: var(--g-color-line-generic-active);
}
.yc-select-control_stretched {
  width: 100%;
  overflow: hidden;
}
.yc-select-control_disabled {
  color: var(--g-color-text-hint);
  pointer-events: none;
}
.yc-select-control_disabled::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--yc-select-background-color-disabled, var(--g-color-base-generic-accent-disabled));
}
.yc-select-control:hover {
  border-color: var(--g-color-line-generic-hover);
  background-color: var(--yc-select-background-color-hover, var(--g-color-base-simple-hover));
}
.yc-select-control:active:not(.yc-select-control_without-animation) {
  transform: scale(0.98);
}
.yc-select-control_error {
  border-color: var(--g-color-line-danger);
}
.yc-select-control_error:hover {
  border-color: var(--g-color-line-danger);
}
.yc-select-control__label {
  font-weight: var(--g-text-accent-font-weight);
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: 6px;
  white-space: nowrap;
}
.yc-select-control__label_limited {
  max-width: 50%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}
.yc-select-control__tokens {
  display: flex;
  align-items: center;
  line-height: 26px;
  flex: 1 1 auto;
  white-space: nowrap;
  overflow: hidden;
}
.yc-select-control__tokens-text {
  padding-right: 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.yc-select-control__tokens-text_empty {
  color: var(--g-color-text-hint);
}
.yc-select-control__placeholder-icon, .yc-select-control__selected-item-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 16px;
  height: 16px;
  margin-right: 5px;
}
.yc-select-control__badge {
  display: flex;
  align-items: center;
  height: 20px;
  padding: 0 6px;
  background-color: var(--yc-select-badge-color, var(--g-color-base-selection));
  border-radius: 4px;
  transition: background-color 0.1s linear;
}
.yc-select-control__badge_clicked {
  background-color: var(--g-color-base-brand);
  color: var(--g-color-text-light-primary);
}
.yc-select-control__badge_without-arrow {
  margin-right: 3px;
}
.yc-select-control__arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 30px;
  height: 100%;
}
.yc-select-control__arrow_loading {
  margin-left: auto;
}
.yc-select-control__loader {
  display: flex;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.yc-select-action {
  padding: 0 2px 2px;
}

.yc-select-popup {
  max-width: 400px;
  overflow: hidden;
  color: var(--g-color-text-primary);
}
.yc-select-popup_multi {
  min-width: 150px;
}
.yc-select-popup_search {
  min-width: 170px;
}
.yc-select-popup_search.yc-select-popup_multi {
  min-width: 200px;
}
.yc-select-popup__select-title {
  font-weight: var(--g-text-accent-font-weight);
  padding: 12px 0 4px 16px;
}
.yc-select-popup__loader {
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.yc-select-popup__loader_mobile {
  padding: 35px;
}

.yc-select-sheet {
  --g-sheet-content-padding: 0;
  overflow: hidden;
}
.yc-select-sheet .yc-sheet__sheet-content-title {
  padding-bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/common/YCSelect/YCSelect.scss","webpack://./node_modules/@gravity-ui/uikit/styles/mixins.scss"],"names":[],"mappings":"AAEA;EAGI,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,6CAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,kEACI;EAEJ,eAAA;EACA,aAAA;EACA,kCAAA;EACA,2DAAA;AALJ;AAQQ;EACI,YAAA;EACA,iBAAA;EACA,eAAA;EACA,uCAAA;AANZ;AASQ;EACI,YAAA;EACA,iBAAA;EACA,eAAA;EACA,uCAAA;AAPZ;AAUQ;EACI,YAAA;EACA,iBAAA;EACA,eAAA;EACA,uCAAA;AARZ;AAWQ;EACI,YAAA;EACA,iBAAA;EACA,eAAA;EACA,wCAAA;AATZ;AAYQ;EACI,YAAA;EACA,iBAAA;EACA,eAAA;EAEA,kBAAA;AAXZ;AAaY;EACI,mBAAA;AAXhB;AAgBI;EAGI,gDAAA;AAhBR;AAmBI;EACI,WAAA;EACA,gBAAA;AAjBR;AAoBI;EACI,+BAAA;EACA,oBAAA;AAlBR;AAoBQ;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,yGAAA;AAlBZ;AAyBI;EACI,+CAAA;EACA,2FAAA;AAvBR;AA0BI;EACI,sBAAA;AAxBR;AA2BI;EACI,wCAAA;AAzBR;AA2BQ;EACI,wCAAA;AAzBZ;AA6BI;EC6MA,6CAAA;ED3MI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AA3BR;AA6BQ;EACI,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;AA3BZ;AA+BI;EACI,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AA7BR;AAgCI;EACI,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AA9BR;AAgCQ;EACI,+BAAA;AA9BZ;AAkCI;EAEI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAjCR;AAoCI;EACI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,6EAAA;EACA,kBAAA;EACA,wCAAA;AAlCR;AAoCQ;EACI,2CAAA;EACA,wCAAA;AAlCZ;AAqCQ;EACI,iBAAA;AAnCZ;AAuCI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;AArCR;AAuCQ;EACI,iBAAA;AArCZ;AAyCI;EACI,aAAA;EACA,kBAAA;EACA,SAAA;EACA,2BAAA;AAvCR;;AA2CA;EACI,kBAAA;AAxCJ;;AA2CA;EACI,gBAAA;EACA,gBAAA;EACA,kCAAA;AAxCJ;AA0CI;EACI,gBAAA;AAxCR;AA2CI;EACI,gBAAA;AAzCR;AA4CI;EACI,gBAAA;AA1CR;AA6CI;ECmGA,6CAAA;EDjGI,wBAAA;AA3CR;AA8CI;EACI,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA5CR;AA8CQ;EACI,aAAA;AA5CZ;;AAiDA;EACI,4BAAA;EACA,gBAAA;AA9CJ;AAgDI;EACI,iBAAA;AA9CR","sourcesContent":[".yc-select-control {\n  box-sizing: border-box;\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  padding-left: 8px;\n  border: 1px solid var(--g-color-line-generic);\n  border-radius: 3px;\n  user-select: none;\n  transition: border-color 0.1s linear, background-color 0.1s linear;\n  cursor: pointer;\n  outline: none;\n  color: var(--g-color-text-primary);\n  background-color: var(--yc-select-background-color, \"none\");\n}\n.yc-select-control_size_xs {\n  height: 24px;\n  line-height: 24px;\n  font-size: 13px;\n  border-radius: var(--g-border-radius-s);\n}\n.yc-select-control_size_s {\n  height: 28px;\n  line-height: 28px;\n  font-size: 13px;\n  border-radius: var(--g-border-radius-m);\n}\n.yc-select-control_size_m {\n  height: 32px;\n  line-height: 36px;\n  font-size: 13px;\n  border-radius: var(--g-border-radius-l);\n}\n.yc-select-control_size_n {\n  height: 36px;\n  line-height: 36px;\n  font-size: 13px;\n  border-radius: var(--g-border-radius-xl);\n}\n.yc-select-control_size_promo {\n  height: 44px;\n  line-height: 44px;\n  font-size: 15px;\n  padding-left: 12px;\n}\n.yc-select-control_size_promo .yc-select-control__tokens-text {\n  padding-right: 12px;\n}\n.yc-select-control_focused, .yc-select-control_focused.yc-select-control:hover:not(.yc-select-control_error), .yc-select-control:focus:not(.yc-select-control_error) {\n  border-color: var(--g-color-line-generic-active);\n}\n.yc-select-control_stretched {\n  width: 100%;\n  overflow: hidden;\n}\n.yc-select-control_disabled {\n  color: var(--g-color-text-hint);\n  pointer-events: none;\n}\n.yc-select-control_disabled::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: var(--yc-select-background-color-disabled, var(--g-color-base-generic-accent-disabled));\n}\n.yc-select-control:hover {\n  border-color: var(--g-color-line-generic-hover);\n  background-color: var(--yc-select-background-color-hover, var(--g-color-base-simple-hover));\n}\n.yc-select-control:active:not(.yc-select-control_without-animation) {\n  transform: scale(0.98);\n}\n.yc-select-control_error {\n  border-color: var(--g-color-line-danger);\n}\n.yc-select-control_error:hover {\n  border-color: var(--g-color-line-danger);\n}\n.yc-select-control__label {\n  font-weight: var(--g-text-accent-font-weight);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-right: 6px;\n  white-space: nowrap;\n}\n.yc-select-control__label_limited {\n  max-width: 50%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: block;\n}\n.yc-select-control__tokens {\n  display: flex;\n  align-items: center;\n  line-height: 26px;\n  flex: 1 1 auto;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.yc-select-control__tokens-text {\n  padding-right: 8px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.yc-select-control__tokens-text_empty {\n  color: var(--g-color-text-hint);\n}\n.yc-select-control__placeholder-icon, .yc-select-control__selected-item-icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 16px;\n  height: 16px;\n  margin-right: 5px;\n}\n.yc-select-control__badge {\n  display: flex;\n  align-items: center;\n  height: 20px;\n  padding: 0 6px;\n  background-color: var(--yc-select-badge-color, var(--g-color-base-selection));\n  border-radius: 4px;\n  transition: background-color 0.1s linear;\n}\n.yc-select-control__badge_clicked {\n  background-color: var(--g-color-base-brand);\n  color: var(--g-color-text-light-primary);\n}\n.yc-select-control__badge_without-arrow {\n  margin-right: 3px;\n}\n.yc-select-control__arrow {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 30px;\n  height: 100%;\n}\n.yc-select-control__arrow_loading {\n  margin-left: auto;\n}\n.yc-select-control__loader {\n  display: flex;\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.yc-select-action {\n  padding: 0 2px 2px;\n}\n\n.yc-select-popup {\n  max-width: 400px;\n  overflow: hidden;\n  color: var(--g-color-text-primary);\n}\n.yc-select-popup_multi {\n  min-width: 150px;\n}\n.yc-select-popup_search {\n  min-width: 170px;\n}\n.yc-select-popup_search.yc-select-popup_multi {\n  min-width: 200px;\n}\n.yc-select-popup__select-title {\n  font-weight: var(--g-text-accent-font-weight);\n  padding: 12px 0 4px 16px;\n}\n.yc-select-popup__loader {\n  padding: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.yc-select-popup__loader_mobile {\n  padding: 35px;\n}\n\n.yc-select-sheet {\n  --g-sheet-content-padding: 0;\n  overflow: hidden;\n}\n.yc-select-sheet .yc-sheet__sheet-content-title {\n  padding-bottom: 0;\n}",null],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
